import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-features-section',
  templateUrl: './features-section.component.html',
  styleUrl: './features-section.component.scss',
  standalone: true,
  imports: [SharedModule, MatIconModule],
})
export class FeaturesSectionComponent {
  features: any[] = [
    {
      title: 'Crystal-clear HD meetings',
      description:
        'Studio-grade video and audio that make every participant feel across the table — not across the country.',
      icon: '../../../../assets/svg/hdvideo_audio.svg',
    },
    {
      title: 'Government-grade security',
      description:
        'End-to-end encryption, role-based controls, and sovereign hosting trusted by Tanzania\'s most sensitive institutions.',
      icon: '../../../../assets/svg/security.svg',
    },
    {
      title: 'Scheduling that just works',
      description:
        'One link to invite. Calendar sync in both directions. Timezone-aware. Reminders your team actually opens.',
      icon: '../../../../assets/svg/scheduling.svg',
    },
    {
      title: 'Insight-rich reports',
      description:
        'Attendance, duration, and decision records — automatically. Prove impact to leadership without a spreadsheet.',
      icon: '../../../../assets/svg/reports.svg',
    },
    {
      title: 'Smart room reservations',
      description:
        'Book meeting spaces across every branch with a single calendar. No double-bookings, no awkward hallway conversations.',
      icon: '../../../../assets/svg/reservations.svg',
    },
    {
      title: 'Your own branded instance',
      description:
        'Dedicated environments with your logo, colors, and policies. For agencies that need isolation without lifting a server.',
      icon: '../../../../assets/svg/instance.svg',
    },
  ];
}
